import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-show-hide-password',
  templateUrl: './show-hide-password.component.html',
  styleUrls: ['./show-hide-password.component.sass'],
})
export class ShowHidePasswordComponent {
  @ViewChild('inputContainer') inputContainer!: ElementRef;
  @Input() hasRequiredError = false;
  public showPassword = false;
  readonly faHide = faEyeSlash;
  readonly faShow = faEye;

  toggleShow() {
    this.showPassword = !this.showPassword;
    this.inputContainer.nativeElement.firstElementChild.type = this.showPassword
      ? 'text'
      : 'password';
  }
}
